
export enum JobStateTypeCd {
	DISABLED = 'Disabled',
	ENABLED = 'Enabled',
	PAUSED = 'Paused',
	STATE_UNSPECIFIED = 'STATE_UNSPECIFIED',
	UPDATE_FAILED = 'UpdateFailed'}

